import React from "react";

import classes from "./DataOverviewItem.module.scss";

const DataOverviewItem = (props) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.iconWrapper} style={{ backgroundColor: props.color }}>
        <img src={props.img} alt="Icon" className={classes.icon} />
      </div>
      <div className={classes.value} style={{ color: props.color }}>
        {props.value}
      </div>
      <div className={classes.metric}>{props.metric}</div>
    </div>
  );
};

export default DataOverviewItem;
